import ufeApi from 'services/api/ufeApi';

const URL = '/gway/v1/dotcom/auth/v2/resetPassword';
import authUtils from 'utils/Authentication';
import RCPSCookies from 'utils/RCPSCookies';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Reset+Password+API

async function resetPasswordByLogin(email, source, options = {}) {
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;
    const { pk } = options;

    let headers = {};

    if (isAuthServiceResetPassEnabled) {
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
    }

    if (RCPSCookies.isRCPSAuthEnabled()) {
        headers.deviceId = await authUtils.getFingerPrint();
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify({
                type: 'email',
                email,
                source: source || undefined,
                ...(pk ? { pk } : {})
            }),
            headers
        })
        .then(data => {
            return data.errorCode || data.errors ? Promise.reject(data) : data;
        })
        .catch(err => Promise.reject(err));
}

function resetPassword(email, password, confirmPassword, securityToken) {
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;

    let headers = {};

    if (isAuthServiceResetPassEnabled) {
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify({
                type: 'reset',
                email,
                password,
                confirmPassword,
                securityToken: securityToken
            }),
            headers
        })
        .then(data => {
            return data.errorCode || data.errors ? Promise.reject(data) : data;
        })
        .catch(err => Promise.reject(err));
}

export default {
    resetPasswordByLogin,
    resetPassword
};
